import { SafePromise } from '@benzinga/safe-await';
import { proxyClientOptions, RestfulClient, Session, StockSymbol } from '@benzinga/session';
import {
  Candle,
  ChartDataResponse,
  ChartInterval,
  ChartRange,
  CryptoChartMultiply,
  CryptoChartResponse,
  CryptoChartTime,
} from '../entities';
import { ChartEnvironment } from '../environment';
import { chartRoutes } from './routes';

export class ChartRestful extends RestfulClient {
  constructor(session: Session) {
    const env = session.getEnvironment(ChartEnvironment);
    super(env.url, session, {}, proxyClientOptions());
  }

  getChart = (options: {
    symbol: StockSymbol;
    from: string;
    to?: string;
    interval: ChartInterval;
    extendedSession?: 'ANY' | 'REGULAR';
    apiKey?: string;
  }): SafePromise<ChartDataResponse> => {
    const env = this.session.getEnvironment(ChartEnvironment);
    const { apiKey, extendedSession = 'ANY', from, interval, symbol, to } = options;
    const path = this.routePath(chartRoutes.chart);
    const url = this.URL(
      path,
      this.withUpstreamCredentials(
        {
          from,
          interval,
          session: extendedSession,
          symbol,
          to,
        },
        { apikey: apiKey || env.key },
      ),
    );
    return this.get(url, {
      allowsAnonymousAuth: true,
      credentials: 'same-origin',
      includeHeader: { authorization: true },
    });
  };

  getCryptoChart = (
    symbol: StockSymbol,
    from: string,
    to: string,
    multiply: CryptoChartMultiply,
    time: CryptoChartTime,
  ): SafePromise<CryptoChartResponse> => {
    const hostname = new URL(this.session.getEnvironment(ChartEnvironment).cryptoUrl);
    const url = this.URL(`${hostname}api/crypto/chart`, {
      from,
      limit: 500,
      multiply,
      symbol,
      time,
      to,
    });
    return this.get(url, {
      allowsAnonymousAuth: true,
      credentials: 'same-origin',
      includeHeader: { authorization: true },
    });
  };

  getEmbedChart = (symbol: StockSymbol, timeframe: ChartRange): SafePromise<{ data: Candle[] }> => {
    const url = this.URL(`${window.location.origin}/embed/api/chart`, {
      symbol,
      timeframe,
    });
    return this.get(url, {
      allowsAnonymousAuth: true,
      credentials: 'include',
    });
  };
}
